/**
 * Project CMS configuration
 *
 */

export default {

	// Public API

	apiEndpoint: 'https://abstractic.prismic.io/api/v2',

	// Private API
	
	accessToken: 'MC5XeUMyUlNNQUFOWG9mU3Et.77-977-977-977-9J--_ve-_ve-_vUB2cHkm77-9AGIU77-9JiHvv73vv73vv70jeu-_vQFsAO-_ve-_ve-_vQ',
	clientId: 'WyC2RSMAAOXofSq9',
	clientSecret: '0f6ba0dfd5b75d0f315140729b12a07c',

};



// WEBPACK FOOTER //
// ./src/utils/config.js